/**
 * Historic Waveform Component
 * Shows scrolling history of audio levels
 */

import { useAudioLevelHistory } from '../hooks/useAudioLevelHistory';
import { WaveformBar } from './WaveformBar';
import './HistoricWaveform.css';

export function HistoricWaveform() {
  const { getHistory } = useAudioLevelHistory();
  const history = getHistory();

  return (
    <div className="historic-waveform">
      <div className="waveform-container">
        {history.map((point, index) => (
          <WaveformBar key={`${point.timestamp}-${index}`} height={point.level * 100} />
        ))}
      </div>
    </div>
  );
}
